import React from 'react';
import { styled } from 'styled-components';
import { COLORS, computeRemSize } from '@ydistri/theme';

export interface InputNoteProps {
  onClick?: () => void;
  children: React.ReactNode;
}

const InputNoteWrapper = styled.div<{ $pointer?: boolean }>`
  color: ${COLORS.GREY_DARK};
  display: flex;
  gap: ${computeRemSize(4)};
  margin-top: ${computeRemSize(2)};
  align-items: center;
  ${p => p.$pointer && 'cursor: pointer;'}
`;

export const InputNote: React.FC<InputNoteProps> = ({ children, onClick }) => {
  return (
    <InputNoteWrapper data-type="InputNote" $pointer={!!onClick} onClick={onClick}>
      {children}
    </InputNoteWrapper>
  );
};

export default InputNote;
